// *****************************
// *****  Main Navigation  *****
// *****************************

import { Collapse as bsCollapse } from 'bootstrap';
import { breakPoint } from './config';

class ExpandForDesktop {

    constructor(el) {
        this.mobile = true;
        this.el = el; // collapse controller element
        this.resizeRequested = null;
        let target = document.querySelector(el.dataset.bsTarget);
        if(target != null) {
            this.collapseEl = bsCollapse.getOrCreateInstance(target, {
                toggle: false
            });
            if(this.collapseEl != null) {
                this.resize();
                window.addEventListener('resize', () => {
                    if(!this.resizeRequested) {
                        this.resizeRequested = true;
                        setTimeout(() => {
                            this.resize();
                        }, 200);
                    }
                });
            }
        }
    }

    resize() {
        let isMobile = window.innerWidth < breakPoint.LG;
        this.resizeRequested = false;
        if(isMobile != this.mobile) {
            this.mobile = isMobile;
            if(isMobile) {
                this.collapseEl.hide();
                this.el.removeAttribute('disabled');
            } else {
                this.collapseEl.show();
                this.el.setAttribute('disabled',true);
            }
        }
    }

}

// export the default function to create
export function createFrom(wrappers) {
    wrappers.forEach((node) => {
        // if node is an element
        if (node.nodeType === 1) {
            new ExpandForDesktop(node);
        }
    });
}